import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { Button } from '../../ui';
import { Modal } from '../../ui/Modal';

const ModalPermissionNotification = () => {
  const { t } = useTranslation();
  const [search, setSearchParams] = useSearchParams();
  const [isShowModal, onToggleIsShowModal] = useState(
    search.get('modal') === 'permission_notification',
  );

  const removeParams = () => {
    search.delete('modal');
    setSearchParams(search, {
      replace: true,
    });
    onToggleIsShowModal(false);
  };

  return (
    <Modal
      title={t('notification.enable_notifications')}
      onCloseModal={removeParams}
      isShow={isShowModal}
    >
      <div className="tw-pt-3">
        <h6 className="tw-text-[14px] tw-font-[400] tw-text-gray0 tw-line-[24px]">
          {t('notification.get_realtime')}
        </h6>
      </div>
      <div className="tw-flex tw-gap-4 tw-mt-5">
        <Button fullWidth onClick={removeParams}>
          {t('notification.got_it')}
        </Button>
      </div>
    </Modal>
  );
};

export default ModalPermissionNotification;
